module.exports = __webpack_public_path__ + "static/media/studio-3.1d5451ce.jpg";